<template>
  <div class="model-senior-icon" :class="[isActive === floatNavigations.float ? 'floatNavigationLeft' : '']">
    <ul>
      <li>
        <el-link @click="take_chat" :underline="false">
          <el-card
              class="box-card-icon"
              shadow="hover"
              :style="{backgroundColor: floatNavigations.themeColor,color: floatNavigations.fontColor}">
            <div>
              <i class="el-icon-service"></i>
              <p class="plus-icon-title">在线咨询</p>
            </div>
          </el-card>
        </el-link>
      </li>
      <li>
        <el-popover placement="left" trigger="hover" width="260">
          <el-input :disabled="disabled" v-model="phone" placeholder="请输入电话">
            <el-button :disabled="disabled" slot="append" @click="takePhone" icon="el-icon-phone" />
          </el-input>
          <el-card
              slot="reference"
              class="box-card-icon"
              shadow="hover"
              :style="{backgroundColor: floatNavigations.themeColor,color: floatNavigations.fontColor}">
            <div>
              <i class="el-icon-phone-outline"></i>
              <p class="plus-icon-title">电话咨询</p>
            </div>
          </el-card>
        </el-popover>
      </li>
      <li v-show="qqActive">
        <el-link @click="QQTalk" :underline="false">
          <el-card
              class="box-card-icon"
              shadow="hover"
              :style="{backgroundColor: floatNavigations.themeColor,color: floatNavigations.fontColor}">
            <div>
              <svg class="icon" aria-hidden="true"><use xlink:href="#icon-qq"></use></svg>
              <p class="plus-icon-title">QQ咨询</p>
            </div>
          </el-card>
        </el-link>
      </li>
      <li>
        <el-popover placement="left" trigger="hover" width="160">
          <el-image
              fit="fit"
              :src="floatNavigations.codeUrl"
              style="width: 150px; height: 150px"
          />
          <el-card
              slot="reference"
              class="box-card-icon"
              shadow="hover"
              :style="{backgroundColor: floatNavigations.themeColor,color: floatNavigations.fontColor}">
            <div>
              <svg class="icon" aria-hidden="true"><use xlink:href="#icon-weixin"></use></svg>
              <p class="plus-icon-title">微信咨询</p>
            </div>
          </el-card>
        </el-popover>
      </li>
      <li>
        <el-link @click="topFunction" :underline="false">
          <el-card
              class="box-card-icon"
              shadow="hover"
              :style="{backgroundColor: floatNavigations.themeColor,color: floatNavigations.fontColor}">
            <div>
              <i class="el-icon-upload2"></i>
              <p>返回顶部</p>
            </div>
          </el-card>
        </el-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
name: "floatNavigations",
  data() {
    return {
      floatNavigations: {},
      phone: '',
      disabled: false,
      isActive: 'l',
      qqActive: false,
    }
  },
  mounted() {
    this.getPlusIcon(this.$route.query.teamID)
  },
  methods:{
    getPlusIcon(teamID) {
      this.$https({url: 'floatNavigations?teamID='+teamID,method: "get"}).then(backData => {
        if (backData.data.code === 200)
        {
          this.floatNavigations = backData.data.data
          if (this.floatNavigations.phone)
          {
            this.phone = this.floatNavigations.phone
            this.disabled = true
          }
          if (this.floatNavigations.qq)
          {
            this.qqActive = true
          }
        }
      });
    },
    //QQ咨询
    QQTalk() {
      window.open('http://wpa.qq.com/msgrd?v=3&uin='+this.floatNavigations.qq+'&site=qq&menu=yes','_brank');
    },
    //返回顶部
    topFunction() {
      let data = {
        code : '206',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    },
    //电话咨询
    takePhone() {
      let data = {
        code : '205',
        msg : 'success',
        phone: this.phone
      };
      window.parent.postMessage(data, '*');
      this.phone = ''
    },
    //开启聊天窗口
    take_chat()
    {
      let data = {
        code : '201',
        msg : 'success'
      };
      window.parent.postMessage(data, '*');
    },
  },
}
</script>

<style>
.model-senior-icon ul li {
  position: relative;
  display: flex;
  width: 83px;
  height: 70px;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.box-card-icon {
  width: 83px;
}
.model-senior-icon {
  position: absolute;
  right: 0;
}
.box-card-icon .el-card__body {
  padding: 10px 0 !important;
}
.plus-icon-title {
  padding-bottom: 10px;
  border-bottom: 1px solid;
  margin: 6px 0;
  font-size: 14px;
}
.floatNavigationLeft {
  position: absolute;
  left: -40px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/plusIcon.vue